export const onCanChangeData = (length: number) : IChangeData | undefined => {
    if (length != 0)
    {
      return {
        isCanChangeData: false,
        message: 'Данное поле нельзя удалить при наличии партий в документе'
      } as IChangeData
    }
    return undefined
  }